import React from 'react';
import {Space} from "antd";

export const ButtonBar: React.FC<{ children: React.ReactElement | React.ReactElement[] }> = ({ children }) => {
    return (
        <div className={`wrapped-buttons`} style={{ position: "fixed", bottom: 0, left: '250px', right: 0, backgroundColor: "white", padding: '8px' }}>
            <Space direction={`horizontal`}>
                { children }
            </Space>
        </div>
    )
}